import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../../../store/auth.store';
import { helpers } from '../../utils/helpers';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);  
  return next(helpers.setHttpHeaders(req, authStore.token()?.accessToken));
};
